import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { StoreButtons } from "@/components/AppStoreButton";
import { PRIVACY_URL, DRIVER_APP_URL, WEBSITE_URL, SUPPORT_EMAIL, SUPPORT_PHONE, LOGO_URL } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export default function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="bg-giva-navy text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Giva Solutions" className="h-12 w-12 rounded-xl bg-black object-contain" />
              <span className="font-display text-2xl font-black">
                Giva<span className="text-giva-accent">.</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-white/70">{t("footer.tagline")}</p>
            <div className="mt-8">
              <StoreButtons dark testPrefix="footer" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">{t("footer.nav")}</h4>
                <ul className="mt-5 space-y-3 text-sm text-white/80">
                  <li><a href="/#servicos" className="transition-colors hover:text-giva-accent">{t("nav.services")}</a></li>
                  <li><a href="/#como-funciona" className="transition-colors hover:text-giva-accent">{t("nav.how")}</a></li>
                  <li><Link to="/blog" className="transition-colors hover:text-giva-accent">{t("nav.blog")}</Link></li>
                  <li><a href="/#contacto" className="transition-colors hover:text-giva-accent">{t("nav.contact")}</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">{t("footer.company")}</h4>
                <ul className="mt-5 space-y-3 text-sm text-white/80">
                  <li><a href={DRIVER_APP_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-giva-accent">{t("footer.driver")}</a></li>
                  <li><a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-giva-accent">{t("footer.website")}</a></li>
                  <li><a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link" className="transition-colors hover:text-giva-accent">{t("footer.privacy")}</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">{t("footer.access")}</h4>
                <ul className="mt-5 space-y-3 text-sm text-white/80">
                  <li>
                    <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 transition-colors hover:text-giva-accent">
                      <Mail className="h-3.5 w-3.5" /> {SUPPORT_EMAIL}
                    </a>
                  </li>
                  <li>
                    <a href={`tel:${SUPPORT_PHONE}`} className="inline-flex items-center gap-2 transition-colors hover:text-giva-accent">
                      <Phone className="h-3.5 w-3.5" /> {SUPPORT_PHONE}
                    </a>
                  </li>
                  <li><Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-giva-accent">{t("footer.admin")}</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-white/15 pt-8 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} GivaSolutions. {t("footer.rights")}</p>
          <p>{t("footer.slogan")}</p>
        </div>
      </div>
    </footer>
  );
}
